<script setup lang="ts">
/**
 * PiIcon — typed wrapper for PrimeIcons font icons.
 *
 * Usage:
 *   <PiIcon name="home" />
 *   <PiIcon name="chevron-right" class="text-sm text-primary" />
 *
 * Renders: <i class="pi pi-{name}" />
 * Accepts any extra attrs (class, style, etc.) via inheritAttrs.
 */

export type PiIconName =
  | 'angle-right'
  | 'arrow-down'
  | 'arrow-left'
  | 'arrow-right'
  | 'arrow-up'
  | 'bars'
  | 'bell'
  | 'book'
  | 'bookmark'
  | 'bookmark-fill'
  | 'briefcase'
  | 'building'
  | 'building-columns'
  | 'building-columns'
  | 'calendar'
  | 'chart-bar'
  | 'chart-line'
  | 'check'
  | 'check-circle'
  | 'check-square'
  | 'chevron-down'
  | 'chevron-left'
  | 'chevron-right'
  | 'chevron-up'
  | 'circle'
  | 'clock'
  | 'cog'
  | 'comments'
  | 'credit-card'
  | 'dollar'
  | 'download'
  | 'ellipsis-v'
  | 'exclamation-circle'
  | 'exclamation-triangle'
  | 'expand'
  | 'eye'
  | 'file'
  | 'file-check'
  | 'filter'
  | 'folder-open'
  | 'hammer'
  | 'home'
  | 'hourglass'
  | 'id-card'
  | 'images'
  | 'info-circle'
  | 'list-check'
  | 'lock'
  | 'map'
  | 'map-marker'
  | 'minus'
  | 'minus-circle'
  | 'moon'
  | 'percentage'
  | 'phone'
  | 'plus'
  | 'refresh'
  | 'search'
  | 'shield'
  | 'shopping-bag'
  | 'sign-out'
  | 'sliders-h'
  | 'sparkles'
  | 'spinner'
  | 'star-fill'
  | 'sun'
  | 'times'
  | 'user'
  | 'users'
  | 'verified'
  | 'wallet'
  | 'wifi'
  | 'list'
  | 'ban'
  | 'send'
  | 'sort-amount-down'
  | 'sort-amount-up'
  | 'tag'
  | 'th-large'
  | 'box'
  | 'arrow-circle-down'
  | 'arrow-circle-up'
  | 'copy'
  | 'check'
  | 'times-circle'
  | 'envelope'
  | 'arrows-h'
  | 'sync'
  | 'table'
  | 'spin'
  | 'file-pdf'
  | 'file-excel'
  | 'ticket'
  | 'inbox'
  | 'envelope'
  | 'headphones'
  | 'phone'
  | 'clock'
  | 'info-circle'
  | 'question-circle'
  | 'upload'
  | 'eye-slash'
  | 'qrcode'
  | 'key'
  | 'pen-to-square'
  | 'undo'
  | 'star'
  | 'play'
  | 'youtube'

interface Props {
  name: PiIconName
}

defineOptions({ inheritAttrs: false })
defineProps<Props>()
</script>

<template>
  <i :class="`pi pi-${name}`" v-bind="$attrs" />
</template>
